import FetchError from "./fetch.js";

export default class ResponseError extends FetchError {
    name = "ResponseError";

    constructor(message, result) {
        super(message, result);
    }
}
